var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarterIsDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 24.9,
    height: 24.9,
    rx: 12.45,
    fill: "#FFF2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 24.9,
    height: 24.9,
    rx: 12.45,
    stroke: "#FFE7E6",
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.499 15.3281C12.5279 15.3281 12.5573 15.3337 12.584 15.3447C12.6107 15.3558 12.6349 15.3722 12.6553 15.3926C12.6757 15.413 12.6921 15.4372 12.7031 15.4639C12.7141 15.4904 12.7197 15.5191 12.7197 15.5479C12.7197 15.5914 12.7068 15.6347 12.6826 15.6709C12.6584 15.707 12.6241 15.7353 12.584 15.752C12.5437 15.7686 12.4988 15.7731 12.4561 15.7646C12.4135 15.7561 12.3744 15.7348 12.3438 15.7041C12.313 15.6733 12.2917 15.6335 12.2832 15.5908C12.2748 15.5483 12.2793 15.5039 12.2959 15.4639C12.3125 15.4237 12.3408 15.3894 12.377 15.3652C12.413 15.3411 12.4556 15.3282 12.499 15.3281Z",
    fill: "#FF0700",
    stroke: "#FF0700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1399 14.0312C10.7128 14.4083 10.4434 14.9599 10.4434 15.5744C10.4434 16.189 10.7128 16.7406 11.1399 17.1176M13.862 14.0312C14.2891 14.4083 14.5585 14.9599 14.5585 15.5744C14.5585 16.2019 14.2777 16.7638 13.8348 17.1412",
    stroke: "#FF0700",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1184 13C9.3709 13.6236 8.89941 14.536 8.89941 15.5525C8.89941 16.569 9.3709 17.4814 10.1184 18.105M14.882 13C15.6295 13.6236 16.101 14.536 16.101 15.5525C16.101 16.5904 15.6095 17.5197 14.8344 18.144",
    stroke: "#FF0700",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.9502H18.5C18.8038 10.9502 19.0498 11.1962 19.0498 11.5V19.5C19.0498 19.8038 18.8038 20.0498 18.5 20.0498H7C6.69624 20.0498 6.4502 19.8038 6.4502 19.5V11.5C6.4502 11.1962 6.69624 10.9502 7 10.9502Z",
    stroke: "#FF0700",
    strokeWidth: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11V8.75C16.5 6.67893 14.8211 5 12.75 5V5C10.6789 5 9 6.67893 9 8.75V11",
    stroke: "#FF0700",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarterIsDisabled);
export default __webpack_public_path__ + "static/media/starter_is_disabled.dad1dc733307cfadc6a4bf90bce70f75.svg";
export { ForwardRef as ReactComponent };